<template>
  <div class="shop-request-thanks">
    <md-layout md-align="center">
      <md-layout class="card-thanks" md-tag="md-card" md-flex-large= "45" md-flex-xsmall="80">
        <md-layout md-flex-large="100" md-flex-xsmall="100" md-tag="md-card-header" md-align="center">
          <md-layout md-flex-large="90" md-align="center">
            <h3>ご投稿ありがとうございます。</h3>
          </md-layout>
          <md-layout md-flex-large="80" md-align="center">
            <p class="md-subhead">スタッフが確認後、アプリ内に掲載させて頂きます。</p>
          </md-layout>
        </md-layout>
        <md-layout md-tag="md-card-actions" md-flex-large="80" md-flex-xsmall="100">
          <md-layout md-flex-large="30" md-flex-xsmall="50" md-flex-large-offset="10" md-align="center">
            <md-button to="new" class="md-raised md-primary">
              <router-link :to="{ name: 'ShopRequestNew' }">続けて投稿する</router-link>
            </md-button>
          </md-layout>
          <md-layout md-flex-large="40" md-flex-xsmall="50" md-align="center">
            <md-button class="md-raised md-primary">
              <router-link :to="{ name: 'ShopsIndex' }">トップページ</router-link>
            </md-button>
          </md-layout>
        </md-layout>
      </md-layout>
    </md-layout>
  </div>
</template>

<script>
export default {
  name: 'shop-request-thanks',
  mounted () {
    document.getElementsByClassName('shop-request-thanks')[0].style.height = document.documentElement.clientHeight + 'px'
    this.$material.setCurrentTheme('shop_requests')
  },
  destroyed () {
    this.$material.setCurrentTheme('default')
  }
}
</script>

<style scoped>
.card-thanks {
  margin-top: 150px;
}

.shop-request-thanks {
  height: 100%;
  background-image: url('../../assets/bg.png')
}
</style>



// WEBPACK FOOTER //
// src/components/ShopRequests/Thanks.vue